import PosmModel from "../../models/posm/posm.model";
import ViewBase from "../../views/view-base.view";
import TreeInputComponent from "../treeview/tree-input.component";

export default function GoodsLevelHierarchyComponent() {
    ViewBase.call(this);

    let levelList = [];



    let buildPosmHierarchyList = (rawList = []) => {
        levelList = rawList;
    }

    const getProductHierarchyList = () => {
        PosmModel.getPosmMasterHierarchy({
            fromLevel:1,
            toLevel:4
        }).then(buildPosmHierarchyList)
    }

    return {
        oninit: () => {
            getProductHierarchyList();
        },
        view: ({ attrs: { selectedItems, onChange, required, disabled } }) => m(TreeInputComponent, {
            title: this.getText('LT00001208', 'Goods Level'),
            items: levelList,
            selectedItems,
            required,
            disabled,
            onChange
        })

    }
}